const titleSize = "35px"
const textSize = "16px"
const backgroundBlue = "#EDF5F7"
const fontColor = "#434343"
const titleColor = "#1c3b4c"
const paddingLeft = "20px"
const paddingRight = "20px"
const maxWidth = "100%"

export default { titleSize, textSize, backgroundBlue, fontColor, titleColor, paddingLeft, paddingRight, maxWidth };